import React from "react";
import { DEFAULT_CANCELLATION_POLICY } from "./booking";
import { FLOW_DEFAULTS } from "@/components/booking-flow/themes";

/**
 * PolicyCard — the cancellation-policy surface shown on the booking
 * details step. Also rendered by the Booking Page settings preview so
 * what the provider approves is literally what customers see.
 */
export function PolicyCard({ policy }: { policy?: string | null }) {
  return (
    <div style={{
      background: `var(--f-surface, ${FLOW_DEFAULTS.surface})`,
      border: `0.5px solid var(--f-hairline, ${FLOW_DEFAULTS.hairline})`,
      borderRadius: 14,
      padding: '12px 14px',
      boxShadow: FLOW_DEFAULTS.cardShadow,
    }}>
      <div style={{
        fontSize: 10,
        textTransform: 'uppercase' as const,
        letterSpacing: '0.18em',
        fontWeight: 600,
        color: `var(--f-ink-faint, ${FLOW_DEFAULTS.inkFaint})`,
      }}>Cancellation policy</div>
      <p style={{
        margin: '6px 0 0',
        fontSize: 11.5,
        lineHeight: 1.5,
        color: `var(--f-ink-soft, ${FLOW_DEFAULTS.inkSoft})`,
        letterSpacing: '-0.005em',
        whiteSpace: 'pre-line',
      }}>
        {policy?.trim() || DEFAULT_CANCELLATION_POLICY}
      </p>
    </div>
  );
}
